// extracted by mini-css-extract-plugin
module.exports = {"videoWrap":"home-video-module--videoWrap--Pz1F5","embedContainer":"home-video-module--embedContainer--3Imhp"};